import {
  List,
  Datagrid,
  TextField,
  EmailField,
  FunctionField,
  EditButton,
  BulkDeleteButton,
  usePermissions,
} from "react-admin";
import { Box, Typography } from "@mui/material";
export const GroupList = (props) => {
  const { permissions = [] } = usePermissions();

  return (
    <List title="Groups" {...props}>
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Groups
        </Typography>
      </Box>
      <Datagrid
        rowClick="show"
        bulkActionButtons={
         permissions.includes("groups.delete") || permissions.includes("groups.*") || permissions.includes("*")
            ? <BulkDeleteButton />
            : false
        }
      >
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="description" />

        {permissions.includes("groups.edit") && <EditButton />}
        {permissions.includes("*") && <EditButton />}
        {permissions.includes("groups.*") && <EditButton />}
        
      </Datagrid>
    </List>
  );
};
